(function (root, doc) {
    'use strict';
    var box = doc.querySelector('[data-nowe-losowania]');
    if (!box || !root.PewniakiZestawy) return;

    var shop = root.PewniakiZestawy.sklep();
    if (!shop) return;
    var rows = Array.prototype.slice.call(box.querySelectorAll('[data-nowe-losowania-gra]'));

    function render() {
        var count = 0;
        rows.forEach(function (row) {
            var game = row.getAttribute('data-nowe-losowania-gra');
            var drawId = row.getAttribute('data-losowanie') || '';
            row.hidden = !shop.nowszeNizWidziane(game, drawId);
            if (!row.hidden) count++;
        });
        box.hidden = count === 0;
    }

    box.addEventListener('click', function (event) {
        var link = event.target.closest('[data-nowe-losowania-link]');
        if (!link || !box.contains(link)) return;
        var row = link.closest('[data-nowe-losowania-gra]');
        if (!row) return;
        shop.zapiszWidziane(row.getAttribute('data-nowe-losowania-gra'), row.getAttribute('data-losowanie') || '');
        render();
    });
    doc.addEventListener('pewniaki:zestawy-zmiana', render);
    root.addEventListener('storage', function (event) {
        if (event.key === shop.KLUCZ || event.key === root.PewniakiZestawy.KLUCZ_WIDZIANE) render();
    });
    render();
})(window, document);